export default __webpack_public_path__ + "static/media/pepper.ce457b74.png";